import { render } from "./ForumView.vue?vue&type=template&id=8d43f3e8"
import script from "./ForumView.vue?vue&type=script&lang=js"
export * from "./ForumView.vue?vue&type=script&lang=js"

import "./ForumView.vue?vue&type=style&index=0&id=8d43f3e8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__